import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import { setItem } from "../../redux/Reducers/createPostReducer";
import { styles } from "./CreatePostStyles";
import Section from "./Section";
import { T } from "react-translator-component";

export default function Title() {
  const dispatch = useAppDispatch();

  const title = useSelector((state: any) => state.createPost.values.title);
  const errors = useSelector((state: any) => state.createPost.errors);

  return (
    <Section
      title={`${T("title")}${T("required")}`}
      body={
        <TextField
          onChange={(e) => dispatch(setItem({key: 'title', value: (e.target.value)}))}
          inputProps={{ maxLength: 2500 }}
          sx={ styles.inputField }
          hiddenLabel
          multiline
          value={title}
          rows={4}
          FormHelperTextProps={{ style: styles.errorMessage }}
          error={!!errors.title}
          helperText={errors.title}
        />
      }
    />
  )
}
